export default __webpack_public_path__ + "static/media/flexible-gs.d5a4f812.svg";